export const TASK_PRIORITIES = ['baja', 'media', 'alta', 'critica'] as const;
export type TaskPriority = (typeof TASK_PRIORITIES)[number];

export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  baja: 'Baja',
  media: 'Media',
  alta: 'Alta',
  critica: 'Crítica',
};

export const TASK_PRIORITY_COLORS: Record<TaskPriority, string> = {
  baja: 'var(--color-fg-subtle)',
  media: 'var(--color-fg-muted)',
  alta: 'var(--color-warning)',
  critica: 'var(--color-danger)',
};

// SLA en horas — debe coincidir con backend. Usado para preview en form.
export const SLA_HOURS_BY_PRIORITY: Record<TaskPriority, number> = {
  critica: 2,
  alta: 24,
  media: 72,
  baja: 168,
};
